<template>
  <div class="header">
    <div class="container">
      <img :src="logo" alt="" class="logo" @click="fh">
      <div class="nav">
        <div class="item" v-for="(item,index) in list" @click="tz(item.title)">
          <div class="name">{{ item.title }}</div>
          <div class="sub">
            <div class="sub-item" v-if="item.sub.length>1" :style="{borderTop:subIndex>0?'none':'',borderBottom:subIndex==item.sub.length-1?'0':''}" v-for="(subItem,subIndex) in item.sub" @click="tz(subItem.name)">
              <div class="subName">{{ subItem.name}}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Header",
  data() {
    return {
      selIndex:-1,
      logo: require('@/assets/log.png'),
      list: [
        {
          title: '首页',
        },
        {
          title: '公司介绍'
        },
        {
          title: '业务范围',
          sub:[
            {
              name:'安全'
            },
            {
              name:'环境'
            },
            {
              name:'职业卫生'
            }
          ]
        },
        {
          title: '文件公示'
        },
        {
          title: '公司资质'
        },
        {
          title: '联系方式'
        },
      ]
    }
  },
  methods: {
    fh(){
      this.$router.push('./')
    },
    tz(name) {
      if(name==='安全'){
        this.$router.push({path:'./pubList?index='+1})
      }
      else if(name==='环境'){
        this.$router.push({path:'./pubList?index='+2})
      }
      else if(name==='职业卫生'){
        this.$router.push({path:'./pubList?index='+3})
      }else if(name==='文件公示'){
        this.$router.push('./docList')
      }else if(name==='公司资质'){
        this.$router.push('./Company')
      }else if(name==='公司介绍'){
        this.$router.push('./Introduce')
      }else if(name==='联系方式'){
        this.$router.push('./Phone')
      }else if(name==='首页'){
        this.$router.push('./')
      }
    },
  }
}
</script>

<style scoped lang="scss">
.header {
  position: fixed;
  left: 0;
  top: 0;
  z-index: 999;
  width: 100%;
  height: 85px;
  //background: #FFFFFF;
  background: #0f1612;
  opacity: 0.8;

  .container {
    max-width: 1318px;
    min-width: 1180px;
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-between;
    margin: 0 auto;
    position: relative;

    .logo {
      width: 313px;
      height: 56px;
      object-fit: fill;
      margin: 15px 0;
      cursor: pointer;
    }

    .nav {
      display: flex;
      flex-flow: row nowrap;
      padding-right: 130px;
      padding-left: 130px;
      //background: #239584;

      .item {
        display: flex;
        //flex-flow: column nowrap;
        //height: inherit;
        justify-content: center;
        align-items: center;
        box-sizing: border-box;
        position: relative;
        //background: #239584;

        .sub {
          width: 124px;
          display: none;
          position: absolute;
          z-index: 2000;
          top: 85px;
          left: 0;
          background-color: white;
          backdrop-filter: blur(5px);

          .sub-item {
            width: 100%;
            display: flex;
            flex-flow: column nowrap;
            justify-content: center;
            align-items: center;
            height: 62px;
            text-align: center;
            transition: all .3s;
            font-size: 16px;
            color: #ffffff;
            background: #0f1612;
            border-top: .2px solid #ffffff;
            opacity: 0.8;
            border-bottom: 0.5px solid #ffffff;
            border-top: 0px;
            &:hover {
              //background-color: rgba(255, 255, 255, .2);
              cursor: pointer;
            }
            .subName {
              width: 64px;
              height: 22px;
              line-height: 22px;
              //padding: 0 30px;
              font-weight: 400;
              font-size: 16px;
              //background: rgba(255, 255, 255, 0.2);
              //border-bottom-color: #3EE6AF;
              cursor: pointer;
              color: white;
            }
          }



        }
        &:hover {
          cursor: pointer;
        }
        .name {
          width: 64px;
          height: 22px;
          color: white;
          line-height: 22px;
          padding: 0 30px;
          font-weight: 400;
          font-size: 16px;
          text-align: center;
        }
        &:hover {


          .sub {
            display: block;
            cursor: pointer;
          }
        }
      }
    }
  }
}
</style>
